// useInput.ts
import React, { SetStateAction } from 'react'

export const useInput = <T>(
  setData: React.Dispatch<SetStateAction<T>>,
  checkAndAddValidation?: (fieldName: string) => void,
) => {
  const inputHandler = <T>(value: T, fieldName: string, type: string) => {
    checkAndAddValidation && checkAndAddValidation(fieldName)
    
    if (type === 'array' && Array.isArray(value)) {
      setData(prevState => ({
        ...prevState,
        [fieldName]: [...value],
      }))
    } else if (type === 'checkbox') {
      setData(prevState => ({
        ...prevState,
        //@ts-ignore
        [fieldName]: !prevState[fieldName],
      }))
    } else if (type === 'number') {
      setData(prevState => ({
        ...prevState,
        [fieldName]: Number(value),
      }))
    } else if (type === 'Date') {
      setData(prevState => ({
        ...prevState,
        [fieldName]: String(value),
      }))
    } else if (type === 'numberText') {
      // Для numberText сохраняем как строку, но только цифры
      const strValue = String(value).replace(/[^\d]/g, '')
      
      // Блокируем множественные нули в начале
      if (strValue.length > 1 && strValue[0] === '0') {
        return // Не обновляем состояние
      }
      
      setData(prevState => ({
        ...prevState,
        [fieldName]: strValue,
      }))
    } else {
      setData(prevState => ({
        ...prevState,
        [fieldName]: value,
      }))
    }
  }

  return { inputHandler }
}